import ApiService from '@shared/services/api.service';

// URL-keyed cache for read-only metric aggregates: de-dupes concurrent identical
// calls, serves repeats within the TTL, and is namespaced by user (scope) since
// the metrics URLs resolve the impersonated user server-side.

const DEFAULT_TTL = 60 * 1000;
const store = new Map(); // key -> { data, expires } | { inflight }
let scope = '';

export function setCacheScope(next) {
  const s = next == null ? '' : String(next);
  if (s === scope) return;
  scope = s;
  store.clear();
}

export function cachedGet(resource, ttl = DEFAULT_TTL) {
  const key = `${scope}|${resource}`;
  const hit = store.get(key);
  if (hit) {
    if (hit.inflight) return hit.inflight;
    if (hit.expires > Date.now()) return Promise.resolve(hit.data);
  }

  const inflight = ApiService.get(resource)
    .then((data) => {
      store.set(key, { data, expires: Date.now() + ttl });
      return data;
    })
    .catch((err) => {
      store.delete(key); // never cache errors
      throw err;
    });

  store.set(key, { inflight });
  return inflight;
}

// Seed the cache from data fetched another way (e.g. the batch response) under
// the same key cachedGet uses.
export function primeCache(resource, data, ttl = DEFAULT_TTL) {
  store.set(`${scope}|${resource}`, { data, expires: Date.now() + ttl });
}

export function clearMetricsCache() {
  store.clear();
}
